import React, {useState, useEffect} from "react";
import {CardContactMap, SubtitleContact, TextContact, CardContactInfo} from "./ContactStyles";
import {Content} from "../../../styles/GlobalStyles";
import Person from "../../../assets/icons/icon_person_referencias.png";
import Auto from "../../../assets/icons/icon_valet_referencias.png";
import Moto from "../../../assets/icons/icon_bike_referencias.png";
import Color from "../../../assets/Colors";
// import {CardWhiteCoach, CardCoach} from "../../course_details/components/FacilitadorStyle";
import {ContentContainer} from "../../../styles/Products";
import {ViewAcademy} from "../../domecq_academy/components/AcademyStyles";
import {CardCoach} from "../../course_details/components/FacilitadorStyle";

export default function Bienvenida() {
   const [isMobile, setMobile] = useState(true);
   useEffect(() => {
      setMobile(window.screen.width < 500);
   }, []);
   if (isMobile) {
      return (
         <ViewAcademy>
            <Content>
               <ContentContainer>
                  <CardCoach width="100%" className="full noMarginMobile">
                     <iframe src="https://snazzymaps.com/embed/233621" width="100%" height="600px" style={{border: "none"}}></iframe>
                     {/* <img src={require("../../../assets/image/views/mapa_mobile.png")} alt="experience" className="profileImg" /> */}
                     <CardContactMap className="contact">
                        <img src={require("../../../assets/icons/location.png")} alt="location" className="icon" />
                        <CardContactInfo>
                           <SubtitleContact>NUESTRA UBICACIÓN</SubtitleContact>
                           <TextContact className="styleMobile">
                              Domecq Academy se encuentra ubicado dentro del Coporativo Casa Pedro Domecq en el corazón de Polanco. <br />{" "}
                              <br />
                              Avenida Presidente Masaryk 275. Colonia Polanco. 11550. CDMX (Entrada por Temístocles).
                           </TextContact>
                        </CardContactInfo>

                        <CardContactInfo>
                           <SubtitleContact weight="400" transform="initial">
                              Referencias
                           </SubtitleContact>
                           <TextContact>
                              <img style={{width: "10px", marginRight: "23px"}} src={Person} alt="person" /> A 1 cuadra de metro Polanco.
                           </TextContact>
                           <TextContact>
                              <img style={{width: "16px", marginRight: "17px"}} src={Auto} alt="auto" /> Valet parking disponible con costo.
                           </TextContact>
                           <TextContact>
                              <img style={{width: "18px", marginRight: "14px"}} src={Moto} alt="moto" /> Espacio para estacionar
                              motocicletas cruzando la calle.
                           </TextContact>
                           <br />
                           <TextContact>Email: domecqacademy@pedrodomecq.com</TextContact>
                        </CardContactInfo>
                     </CardContactMap>
                  </CardCoach>
               </ContentContainer>
            </Content>
         </ViewAcademy>
      );
   }

   return (
      <ViewAcademy>
         <Content>
            <ContentContainer>
               <CardCoach width="100%" className="full">
                  <iframe src="https://snazzymaps.com/embed/233621" width="100%" height="600px" style={{border: "none"}}></iframe>

                  {/* <img src={require("../../../assets/image/views/map_domecq.png")} alt="experience" className="profileImg" /> */}
                  <CardContactMap className="contact">
                     <img src={require("../../../assets/icons/location.png")} alt="location" className="icon" />
                     <div className="sect">
                        <SubtitleContact>NUESTRA UBICACIÓN</SubtitleContact>
                        <TextContact>
                           Domecq Academy se encuentra ubicado dentro del Coporativo Casa Pedro Domecq en el corazón de Polanco. <br />{" "}
                           <br />
                           Avenida Presidente Masaryk 275. Colonia Polanco. 11550. CDMX (Entrada por Temístocles).
                        </TextContact>
                     </div>
                     <div className="sect">
                        <SubtitleContact weight="400" transform="initial">
                           Referencias
                        </SubtitleContact>
                        <TextContact>
                           <img style={{width: "10px", marginRight: "23px"}} src={Person} alt="person" /> A 1 cuadra de metro Polanco.
                        </TextContact>
                        <TextContact>
                           <img style={{width: "16px", marginRight: "17px"}} src={Auto} alt="auto" /> Valet parking disponible con costo.
                        </TextContact>
                        <TextContact>
                           <img style={{width: "18px", marginRight: "14px"}} src={Moto} alt="moto" /> Espacio para estacionar motocicletas
                           cruzando la calle.
                        </TextContact>
                        <br />
                        <TextContact>Email: domecqacademy@pedrodomecq.com</TextContact>
                     </div>
                  </CardContactMap>
               </CardCoach>
            </ContentContainer>
         </Content>
      </ViewAcademy>
   );
}

/* export default function MapComponent() {
   return (
      <CardContactMap> 
         <Content className="contact">
            
         </Content>
      </CardContactMap>
   );
}
 */
